import React, { FC } from 'react'

import { FieldErrors, UseFormRegister } from 'react-hook-form'

import { TextField } from 'src/components/atoms'
import { ChangePasswordItem } from 'src/components/molecules'

import { UpdatePasswordFormEntity } from 'src/types'

type Props = {
  register: UseFormRegister<UpdatePasswordFormEntity>
  formErrors: FieldErrors<UpdatePasswordFormEntity>
  className?: string
}

export const ChangePassword: FC<Props> = ({ register, formErrors, className }) => {
  return (
    <div className={className}>
      <ChangePasswordItem title="現在のパスワード">
        <TextField
          {...register('oldPassword')}
          type="password"
          placeholder="8文字以上の英数字"
          errorMessage={formErrors.oldPassword?.message}
        />
      </ChangePasswordItem>
      <ChangePasswordItem title="新しいパスワード" className="tw-mt-s0">
        <TextField
          {...register('newPassword')}
          type="password"
          placeholder="8文字以上の英数字"
          errorMessage={formErrors.newPassword?.message}
        />
      </ChangePasswordItem>
      <ChangePasswordItem title="パスワード再入力" className="tw-mt-s0">
        <TextField
          {...register('newPasswordConfirm')}
          type="password"
          placeholder="パスワード再入力"
          errorMessage={formErrors.newPasswordConfirm?.message}
        />
      </ChangePasswordItem>
    </div>
  )
}
